module.exports = __webpack_public_path__ + "static/media/mail.6b7a674d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/mail.svg
// module id = 28
// module chunks = 0